import { render, staticRenderFns } from "./ConsultingBook.vue?vue&type=template&id=3bc6bf5b"
import script from "./ConsultingBook.vue?vue&type=script&lang=js"
export * from "./ConsultingBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports